import { render } from "./BlockHead.vue?vue&type=template&id=2f47a869"
import script from "./BlockHead.vue?vue&type=script&lang=js"
export * from "./BlockHead.vue?vue&type=script&lang=js"
script.render = render

export default script